import React from 'react';
import ContentLoader from 'react-content-loader';

import Theme from 'styles/theme';

const WIDTH = 300;

const ChildNamePlaceholder = props => (
  <ContentLoader
    height={Theme.get('spacing') * 8}
    width={WIDTH}
    primaryColor={Theme.get('colors-grey')}
    secondaryColor={Theme.get('colors-grey')}
    animate={false}
    {...props}
  >
    <rect x={0} y={0} width={(WIDTH * 2) / 3} height={Theme.get('spacing') * 3} />
    <rect x={0} y={Theme.get('spacing') * 4} width={WIDTH} height={Theme.get('spacing') * 3} />
  </ContentLoader>
);

ChildNamePlaceholder.propTypes = {};

ChildNamePlaceholder.defaultProps = {};

export default ChildNamePlaceholder;
